module.exports = __webpack_public_path__ + "static/media/triangle_background.fbb59afb.PNG";